// MarketingLander.js
import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import Markdown from './Markdown';

const iframeStyleDefault = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  border: 0
};

const mediaWrapStyle = {
  position: 'relative',
  width: '100%',
  height: '100vh',      // use this instead of paddingTop
  //paddingTop: '56.25%', // 16:9
    marginLeft: 'auto',   // right-align
  marginRight: 0,
  overflow: 'hidden',
  borderRadius: '0.5rem'
};

const imageFillStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'contain'
};
const sectionStyle = {
    minHeight: '100vh',
};

const MarketingLander = ({
  useImageUnderlay = false,
  yt_url = `https://www.youtube.com/embed/gqGCei_DePA?autoplay=1&mute=1&loop=1&controls=0&playlist=gqGCei_DePA&modestbranding=1&playsinline=1&rel=0`,
  img_path = '/ai_banner.png',
  hero_button_label = 'courses',
  hero_button_link = 'http://google.com',
  hero_area_text = "sign up\n\n\n\n\n\n\n\n",
  call_to_action_title = "LEARN \nAI\n ART\n",
  iframeStyle
}) => {
  const frameStyle = iframeStyle || iframeStyleDefault;

  // Split hero text into description + optional sub-description (paragraphs)
  const [desc, ...rest] = String(hero_area_text || '').split(/\n{2,}/);
  const subDesc = rest.join('\n\n');

  return (
<section className=" "  style={sectionStyle}>  
          <Container>
        <Row className="align-items-center g-4">
          {/* Left: media (on mobile this appears first) */}
          <Col xs={12} md={8} className="order-1 order-md-1">
            <div style={mediaWrapStyle}>
              {useImageUnderlay ? (
                <img src={img_path} alt="" style={imageFillStyle} />
              ) : (
                <iframe
                  title="Intro Media"
                  src={yt_url}
                  style={frameStyle}
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          </Col>

          {/* Right: content card without border (on mobile appears second) */}
          <Col xs={12} md={3} className="order-2 order-md-2">
            <Card className="border-0 shadow-none">
              <Card.Body className="p-0">
                <h1 className="fw-bold mb-3" style={{ whiteSpace: 'pre-line' }}>
                  {call_to_action_title}
                </h1>

                {desc ? (
                  <div className="mb-3">
                    <Markdown md={desc} />
                  </div>
                ) : null}

                {subDesc ? (
                  <div className="text-muted mb-4">
                    <Markdown md={subDesc} />
                  </div>
                ) : null}

                <Button
                  variant="danger"
                  size="lg"
                  href={hero_button_link}
                  style={{ fontSize: '1.25rem', padding: '0.9rem 2rem', backgroundColor: 'darkred', borderColor: 'black' }}
                >
                  {hero_button_label}
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={0} md={1} className="order-2 order-md-2"></Col>

        </Row>
      </Container>
    </section>
  );
};

export default MarketingLander;
